<template>
  <header class="header flex items-center space-between">
    <div class="header__logo">
      <router-link :to="{ name: 'Login' }">
        <img src="/picout-logo.svg" alt="picout logo" width="80" height="20" />
      </router-link>
    </div>
    <div class="header__right">
      <template v-if="isAuth">
        <UserAvatarMenu />
      </template>
      <template v-else>
        <div class="header__right__lang">
          <SelectField
            id="selectedLangMainNavBar"
            v-model="selectedLang"
            :options="languageOptions"
            placeholder="Lang"
            icon-class-left="icon-lang"
            icon-class-right="icon-simple-arrow-down"
            @change="changeLanguage(selectedLang)"
          />
        </div>
      </template>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import UserAvatarMenu from '@/components/header/UserAvatarMenu.vue'
import { SelectField } from '@snowshoe-frontend/form-fields-components'
import { useI18n } from 'vue-i18n'
import { useLanguages } from '@/composables/useLanguages'

defineProps({
  isAuth: {
    type: Boolean,
    default: false
  }
})

const { changeLanguage } = useLanguages()
const i18n = useI18n()

const languageOptions = [
  { title: 'En', value: 'en' },
  { title: 'De', value: 'de' }
]

const selectedLang = ref(i18n.locale.value)
</script>

<style lang="scss">
.header {
  padding: var(--grid-12) 0;

  &__right {
    &__lang {
      width: rem(120);
    }
  }
}
</style>
